import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Settings as SettingsIcon } from 'lucide-react';

export default function SettingsPage() {
  const { user } = useAuth();

  return (
    <div className="space-y-4 max-w-2xl" data-testid="settings-page">
      <div className="flex items-center gap-2">
        <SettingsIcon className="w-5 h-5 text-slate-700" />
        <h1 className="text-xl font-bold tracking-tight text-slate-900">Settings</h1>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 space-y-4">
        <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Company Information</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
          <div>
            <p className="text-[10px] text-slate-500 uppercase tracking-wider">Company Name</p>
            <p className="font-medium text-slate-900">IndieEyes Online Services (OPC) Pvt. Ltd.</p>
          </div>
          <div>
            <p className="text-[10px] text-slate-500 uppercase tracking-wider">Country</p>
            <p className="font-medium text-slate-900">India</p>
          </div>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 space-y-4">
        <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Your Profile</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
          <div>
            <p className="text-[10px] text-slate-500 uppercase tracking-wider">Name</p>
            <p className="font-medium text-slate-900">{user?.name}</p>
          </div>
          <div>
            <p className="text-[10px] text-slate-500 uppercase tracking-wider">Email</p>
            <p className="font-medium text-slate-900">{user?.email}</p>
          </div>
          <div>
            <p className="text-[10px] text-slate-500 uppercase tracking-wider">Role</p>
            <p className="font-medium text-slate-900 capitalize">{user?.role}</p>
          </div>
          <div>
            <p className="text-[10px] text-slate-500 uppercase tracking-wider">Expense Limit</p>
            <p className="font-medium text-slate-900">₹{(user?.expenseLimit || 0).toLocaleString('en-IN')}</p>
          </div>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-lg p-4 space-y-3">
        <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-wider">System Rules</h2>
        <ul className="text-xs text-slate-600 space-y-1.5 list-disc list-inside">
          <li>No voucher = No valid expense</li>
          <li>No approval = Payment not complete</li>
          <li>No deletion allowed (only cancel and recreate)</li>
          <li>Full audit trail is maintained for all operations</li>
          <li>Amounts under ₹500 are auto-approved</li>
          <li>₹500-₹5,000 requires manager approval</li>
          <li>₹5,000+ requires admin approval</li>
          <li>₹10,000+ requires additional verification</li>
          <li>Creator cannot approve their own voucher</li>
          <li>Voucher is locked after approval</li>
        </ul>
      </div>
    </div>
  );
}
